import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { forkJoin } from 'rxjs';
import { compare } from 'compare-versions';
import { DeviceService } from 'src/app/services/devices/device.service';
import { LoadingPopupComponent } from 'src/app/components/ui/loading-popup/loading-popup.component';
import { ModalService } from 'src/app/services/modal/modal.service';
import { OCPP_TOP_PROFILES } from 'src/app/pages/device/settings/ocpp/profiles';

interface DestinationImportContext {
  numPhases: number;
  supportsSafetyOnRetries: boolean;
  firmwareVersion: string;
}

interface ImportModuleResult {
  module: string;
  success: boolean;
  message: string;
}


@Component({
    selector: 'app-modules',
    templateUrl: './modules.component.html',
    styleUrls: ['./modules.component.scss'],
    standalone: false
})
export class ModulesComponent implements OnInit {

  serialOrgin: string = '';
  serial: string = '';
  modules: any[] = [];

  successMessage = {
    cfg: '',
    stat: ''
  };
  error = {
    cfg: '',
    stat: ''
  };
  successMessageElement = '';
  errorElement = '';

  document:any = null;
  analyzers: any[] = [];
  formattedData: any[] = [];
  clock : any = null
  object : any

  importErrorMessage: string = '';
  importSuccessMessage: string = '';
  importSummaryMessage: string = '';
  importSummaryType: 'success' | 'warning' | 'danger' = 'success';
  importResults: ImportModuleResult[] = [];
  importedModules: any[] = [];
  selectedImportedModule: any = null;

  private readonly importTargetTopics = ['ocpp', 'sys', 'spl', 'modulator', 'mennekes', 'solar', 'rfid', 'schedman'];
  private readonly importIgnoredKeys = [
    'date_build',
    'timestamp',
    'updFlags',
    'verbosity',
    'recv_seq',
    'maxTemp',
    'minTemp',
    'timeMaxTemp',
    'neutralPe',
    'neutralPeHyst',
  ];

  /** Prefijos de modelo en serial; el orden importa (EVVC1 antes que EVVC3, etc.). */
  private readonly deviceModelPrefixes = ['EVVC1', 'EVVC3', 'EVVC4', 'EVVC5', 'EVVC6', 'M1', 'ANC1', 'ANC2', 'XLUM', 'XEO'];

  private readonly deviceModelLabels: Record<string, string> = {
    EVVC1: 'Combi',
    EVVC3: 'Uni',
    EVVC4: 'CombiPlus',
    EVVC5: 'City+2',
    EVVC6: 'Exo',
  };

  /** Solo aplican en monofásico con firmware >= 7.3.35 (alimentación entre fases B1). */
  private readonly mennekesConditionalKeys = ['safetyOnRetries', 'safetyOnTime'];

  constructor(private _device: DeviceService, private _aRoute: ActivatedRoute, private _modal: ModalService, @Inject(DOCUMENT) document: Document) {
    this.document=document;
  }

  ngOnInit(): void {

    this._aRoute.parent?.params
    .subscribe((params: Params) => {
      this.serial = params['serial'];
      this.loadData();
    });

  }

  loadData(){
    this._device.getModulesByDevice(this.serial, "level=all&elements=true")
      .subscribe(data => {
        this.modules=data;
        /*data.forEach(module => {
          this.modules.push(module.topic_name);
        });
        console.log(this.modules)*/
      })
  }

  getData(module, command, element = undefined){
    var modalLoad = this._modal.open(LoadingPopupComponent);
    var submodule = "";

    if(module == "rfid" || module == "spl" || module == "network"){
      submodule = module;
      module = "sys";
    }
    else if(module == "clock"){
      submodule = module;
      module = "astcal";
    }
    this._device.getModuleInfo(this.serial, module, command, {localdata: true})
    .subscribe(data => {
      console.log(data)
      modalLoad.close();
      if(submodule=="clock"){
        this.modules.find(m=>m.topic_name==submodule)[command] = data[submodule][command];
        this.successMessage[command] = submodule;
      }
      else if(submodule!=""){
        this.modules.find(m=>m.topic_name==submodule)[command] = data.modules[submodule][command];
        this.successMessage[command] = submodule;
      }
      else{
        this.modules.find(m=>m.topic_name==module)[command] = data[command];
        this.successMessage[command] = module;
      }
      setTimeout(() => {
        this.successMessage[command] = '';
      }, 5000);
    }, err => {
      console.error(err)
      this.error[command] = module;
      setTimeout(() => {
        this.error[command] = '';
      }, 5000);
      modalLoad.close();
    });
  }

  getElementData(module, idModule, indexElement){
    var element = this.modules.find(m=>m.topic_name==module).elements[indexElement];
    if(this.document.getElementById("element_tab_"+idModule+"_"+(indexElement+1)+"_1").classList.contains("active"))
      var command = "cfg";
    else
      var command = "stat";
    var modalLoad = this._modal.open(LoadingPopupComponent);
    this._device.getElementModule(this.serial, module, element.name, command , {localdata: true})
    .subscribe(data => {
      console.log(data)
      element.data[command] = data[command];
      modalLoad.close();
      this.successMessageElement = module;
        setTimeout(() => {
          this.successMessageElement = '';
        }, 5000);
    }, err => {
      console.error(err)
      this.errorElement = module;
      setTimeout(() => {
        this.errorElement = '';
      }, 5000);
      modalLoad.close();
    }
  );
  }

  exportModules() {
    const exportData = {
      serial: this.serial,
      modules: this.modules
    };
    const jsonData = JSON.stringify(exportData, null, 2);
    const blob = new Blob([jsonData], { type: 'application/json' });
    const downloadLink = this.document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = `${this.serial}_InfoModulos.json`;
    downloadLink.click();
    URL.revokeObjectURL(downloadLink.href);
  }

  getDataAnalyzers(){
    var modalLoad = this._modal.open(LoadingPopupComponent);
    this._device.getModuleanalyzers(this.serial).subscribe( data=>{
      this.analyzers=data.analyzers
      console.log(this.analyzers)
      this.formattedData = this.analyzers.map(analyzer => ({
        serial: analyzer.serial,
        stat: analyzer.stat
      }))
      modalLoad.close();
      this.successMessageElement = 'Analyzer';
      setTimeout(() => {
        this.successMessageElement = '';
      }, 5000)

  },err => {
    console.error(err)
    this.errorElement = 'Analyzer';
    setTimeout(() => {
      this.errorElement = '';
    }, 5000);
    modalLoad.close();
  }
)
  }

  getAstCalendar(){
    var modalLoad = this._modal.open(LoadingPopupComponent);
    this._device.getModuleInfo( this.serial, 'astcal', 'cfg', {localdata: true})
      .subscribe(  data =>{
        this.clock = data.clock.cfg.geoloc
        modalLoad.close();
        console.log('data clock ', this.clock);
        this.object = JSON.stringify(data)
        console.log(this.object);
      })


  }

  importModules() {
    const input = this.document.getElementById('importFile') as HTMLInputElement | null;

    this.importErrorMessage = '';
    this.importSuccessMessage = '';
    this.importSummaryMessage = '';
    this.importResults = [];
    this.importedModules = [];
    this.selectedImportedModule = null;
    this.serialOrgin = '';

    if (!input?.files?.length) {
      this.importErrorMessage = 'Selecciona un archivo JSON válido.';
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const content = event.target?.result;

        if (typeof content !== 'string') {
          throw new Error('No se ha podido leer el contenido del archivo.');
        }

        const parsedData = JSON.parse(content);

        // Detectar si es la estructura nueva { serial, modules } o solo un array
        let modulesToProcess: any[] = [];
        if (Array.isArray(parsedData)) {
          throw new Error('El archivo debe incluir el serial del dispositivo de origen (formato { serial, modules }).');
        } else if (parsedData && typeof parsedData === 'object' && Array.isArray(parsedData.modules)) {
          this.serialOrgin = parsedData.serial || '';
          modulesToProcess = parsedData.modules;
        } else {
          throw new Error('El archivo debe contener un objeto con { serial, modules }.');
        }

        if (!this.serialOrgin) {
          throw new Error('El archivo debe incluir el serial del dispositivo de origen.');
        }

        const modelValidationError = this.validateImportDeviceModel(this.serialOrgin);
        if (modelValidationError) {
          throw new Error(modelValidationError);
        }

        this.importedModules = modulesToProcess
          .filter(m => m && this.importTargetTopics.includes(this.normalizeTopicName(m.topic_name)))
          .map(m => ({
            topic_name: this.normalizeTopicName(m.topic_name),
            name: m.name || m.topic_name,
            selected: true,
            cfg: this.optimizeConfig(m.cfg),
            elements: this.extractImportElements(m),
          }))
          .filter(m => m.cfg || m.elements.length);

        if (!this.importedModules.length) {
          this.importErrorMessage = `No se encontraron módulos disponibles para importar (${this.importTargetTopics.join(', ')}).`;
          return;
        }

        this.selectedImportedModule = this.importedModules[0];
        const modelPrefix = this.getDeviceModelPrefix(this.serialOrgin);
        const modelLabel = modelPrefix ? this.deviceModelLabels[modelPrefix] : '';
        const modelInfo = modelPrefix
          ? ` · Modelo ${modelPrefix}${modelLabel ? ` (${modelLabel})` : ''}`
          : '';
        const serialInfo = this.serialOrgin ? ` (dispositivo de origen: ${this.serialOrgin}${modelInfo})` : '';
        this.importSuccessMessage = `Detectado${this.importedModules.length > 1 ? 's' : ''} ${this.importedModules.length} módulo${this.importedModules.length > 1 ? 's' : ''} con configuración${serialInfo}.`;

      } catch (err) {
        this.importErrorMessage = err instanceof Error ? err.message : 'El archivo no contiene un JSON válido.';
      }
    };

    reader.onerror = () => {
      this.importErrorMessage = 'No se ha podido leer el archivo seleccionado.';
    };

    reader.readAsText(input.files[0]);
  }

  selectImportedModule(module: any) {
    this.selectedImportedModule = module;
  }

  toggleImportedModuleSelection(module: any, event: Event) {
    const input = event.target as HTMLInputElement;
    module.selected = !!input.checked;
  }

  hasSelectedModules(): boolean {
    return this.importedModules.some(module => !!module.selected);
  }



  private optimizeConfig(cfg: any): Record<string, unknown> | null {
    if (cfg === null || cfg === undefined) return null;
    if (typeof cfg !== 'object' || Array.isArray(cfg)) return null;

    const result = Object.entries(cfg).reduce((acc, [key, value]) => {
      if (this.importIgnoredKeys.includes(key)) return acc;
      const cleaned = this.cleanConfigValue(value);
      if (cleaned !== undefined) acc[key] = cleaned;
      return acc;
    }, {} as Record<string, unknown>);

    return Object.keys(result).length ? result : null;
  }

  /** Omite null/undefined del valor; limpia objetos anidados de forma recursiva. */
  private cleanConfigValue(value: unknown): unknown | undefined {
    if (value === null || value === undefined) return undefined;

    if (Array.isArray(value)) {
      const cleaned = value
        .map(item => this.cleanConfigValue(item))
        .filter(item => item !== undefined);
      return cleaned.length ? cleaned : undefined;
    }

    if (typeof value === 'object') {
      const nested = this.optimizeConfig(value);
      return nested ?? undefined;
    }

    return value;
  }

  private normalizeTopicName(topicName: any): string {
    return String(topicName || '').trim().toLowerCase();
  }

  /** Identifica el prefijo de modelo a partir del serial (p. ej. EVVC37… → EVVC3). */
  private getDeviceModelPrefix(serial: string): string | null {
    const normalized = String(serial || '').trim().toUpperCase();
    if (!normalized) return null;

    for (const prefix of this.deviceModelPrefixes) {
      if (normalized.includes(prefix)) return prefix;
    }
    return null;
  }

  private getDeviceModelLabel(prefix: string): string {
    return this.deviceModelLabels[prefix] || '';
  }

  private validateImportDeviceModel(sourceSerial: string): string | null {
    const sourceModel = this.getDeviceModelPrefix(sourceSerial);
    const destModel = this.getDeviceModelPrefix(this.serial);

    if (!sourceModel) {
      return `No se pudo identificar el modelo del cargador origen (${sourceSerial}).`;
    }
    if (!destModel) {
      return `No se pudo identificar el modelo del cargador destino (${this.serial}).`;
    }
    if (sourceModel === destModel) return null;

    const sourceLabel = this.getDeviceModelLabel(sourceModel);
    const destLabel = this.getDeviceModelLabel(destModel);
    return `El modelo del cargador origen (${sourceModel}${sourceLabel ? ` - ${sourceLabel}` : ''}) ` +
      `no coincide con el destino (${destModel}${destLabel ? ` - ${destLabel}` : ''}).`;
  }

  getConfigSize(cfg: Record<string, unknown> | null | undefined): number {
    if (!cfg || typeof cfg !== 'object' || Array.isArray(cfg)) {
      return 0;
    }
    return Object.keys(cfg).length;
  }

  applyImportedModules() {
    const selectedModules = this.importedModules.filter(module => !!module.selected);

    if (!selectedModules.length) {
      this.importErrorMessage = 'Selecciona al menos un módulo para aplicar.';
      return;
    }

    const selectedNames = selectedModules.map(module => module.name || module.topic_name).join(', ');
    if (!window.confirm(`Se va a aplicar la configuración de [${selectedNames}] del dispositivo ${this.serialOrgin} al dispositivo ${this.serial}. Pulsa OK para continuar.`)) {
      return;
    }

    this.importResults = [];
    this.importErrorMessage = '';
    this.importSuccessMessage = '';
    this.importSummaryMessage = '';

    const modalLoad = this._modal.open(LoadingPopupComponent);
    const needsDestinationContext = selectedModules.some(module => module.topic_name.includes('mennekes'));

    const executeImport = (destinationContext?: DestinationImportContext) => {
      const requests = this.buildImportRequests(selectedModules, destinationContext);

      if (!requests.length) {
        modalLoad.close();
        this.importErrorMessage = 'No hay configuración válida para aplicar.';
        setTimeout(() => { this.importErrorMessage = ''; }, 5000);
        return;
      }

      this.importResults = [];
      let completed = 0;
      const total = requests.length;

      const onDone = () => {
        completed++;
        if (completed < total) return;
        modalLoad.close();
        this.buildImportSummary();

        setTimeout(() => {
          this.importSummaryMessage = '';
        }, 15000);
      };

      requests.forEach(({ module, request }) => {
        request.subscribe({
          next: (data) => {
            const message = this.extractApiResponseMessage(data, true);
            console.log(`[import] ${module} respuesta:`, data);
            this.importResults.push({ module, success: true, message });
            onDone();
          },
          error: (err) => {
            const message = this.extractApiResponseMessage(err?.error ?? err, false);
            console.error(`[import] Error al aplicar ${module}:`, err);
            this.importResults.push({ module, success: false, message });
            onDone();
          }
        });
      });
    };

    if (!needsDestinationContext) {
      executeImport();
      return;
    }

    forkJoin({
      deviceInfo: this._device.getDeviceInfo(this.serial),
      sys: this._device.getModuleInfo(this.serial, 'sys'),
    }).subscribe({
      next: ({ deviceInfo, sys }) => {
        const destinationContext = this.buildDestinationImportContext(deviceInfo, sys);
        console.log('[import] Compatibilidad cargador destino:', {
          serial: this.serial,
          numPhases: destinationContext.numPhases,
          firmwareVersion: destinationContext.firmwareVersion,
          supportsSafetyOnRetries: destinationContext.supportsSafetyOnRetries,
        });
        executeImport(destinationContext);
      },
      error: (err) => {
        console.error('[import] Error al obtener datos del cargador destino:', err);
        modalLoad.close();
        this.importErrorMessage = 'No se pudo comprobar la compatibilidad del cargador destino.';
        setTimeout(() => { this.importErrorMessage = ''; }, 5000);
      },
    });
  }

  private buildImportRequests(
    selectedModules: any[],
    destinationContext?: DestinationImportContext
  ): { module: string; request: ReturnType<DeviceService['setModuleCfg']> }[] {
    const requests: { module: string; request: ReturnType<DeviceService['setModuleCfg']> }[] = [];

    selectedModules.forEach(module => {
      const topic = module.topic_name;

      if (topic.includes('ocpp')) {
        const body = this.buildOcppImportPayload(module.cfg);
        if (body) {
          console.log('[import] Payload ocpp:', body);
          requests.push({ module: 'ocpp', request: this._device.setModuleCfg(this.serial, body, 'ocpp') });
        }
      }
      if (topic.includes('sys')) {
        const body = this.optimizeConfig({
          ampacity: module.cfg?.ampacity,
          maxAmpacity: module.cfg?.maxAmpacity,
        });
        if (body) {
          console.log('[import] Payload sys:', body);
          requests.push({ module: 'sys', request: this._device.setModuleCfg(this.serial, body, 'sys') });
        }
      }
      if (topic.includes('spl')) {
        const body = this.optimizeConfig(module.cfg);
        if (body) {
          console.log('[import] Payload spl:', body);
          requests.push({ module: 'spl', request: this._device.setModuleCfg(this.serial, body, 'spl') });
        }
      }
      if (topic.includes('mennekes')) {
        const body = this.buildMennekesImportPayload(module.elements?.[0]?.cfg, destinationContext);
        if (body) {
          console.log('[import] Payload mennekes:', body);
          requests.push({
            module: 'mennekes',
            request: this._device.setModuleElemData(this.serial, 'mennekes', body),
          });
        }
      }
      if (topic.includes('modulator')) {
        const body = this.optimizeConfig(module.cfg);
        if (body) {
          console.log('[import] Payload modulator:', body);
          requests.push({ module: 'modulator', request: this._device.setModuleCfg(this.serial, body, 'modulator') });
        }
      }
      if (topic.includes('solar')) {
        const body = this.optimizeConfig(module.cfg);
        if (body) {
          console.log('[import] Payload solar:', body);
          requests.push({ module: 'solar', request: this._device.setModuleCfg(this.serial, body, 'solar') });
        }
      }
      if (topic.includes('rfid')) {
        const body = this.buildRfidImportPayload(module.cfg);
        if (body) {
          console.log('[import] Payload rfid:', body);
          requests.push({ module: 'rfid', request: this._device.setModuleCfg(this.serial, body, 'rfid') });
        }
      }
      if (topic.includes('schedman')) {
        const schedmanRequests = this.buildSchedmanImportRequests(module);
        schedmanRequests.forEach(({ module: moduleName, body }) => {
          console.log(`[import] Payload ${moduleName}:`, body);
          requests.push({
            module: moduleName,
            request: body.elementName
              ? this._device.setModuleElement(this.serial, 'schedman', body.payload, body.elementName)
              : this._device.setModuleCfg(this.serial, body.payload, 'schedman'),
          });
        });
      }
    });

    return requests;
  }

  private buildDestinationImportContext(deviceInfo: any, sysData: any): DestinationImportContext {
    const numPhases = this.getNumPhases(sysData);
    const firmwareVersion = deviceInfo?.firmware_version_name ?? '';
    const supportsSafetyOnRetries = numPhases !== 3
      && !!firmwareVersion
      && compare(firmwareVersion, '7.3.35', '>=');

    return { numPhases, supportsSafetyOnRetries, firmwareVersion };
  }

  /** Misma lógica que power-new: fases del cargador según sys. */
  private getNumPhases(sysData: any): number {
    const fwvPot = sysData?.stat?.fwv_pot ?? '';
    const phase = sysData?.cfg?.phase;
    return fwvPot.startsWith('3') ? (phase != 1 ? 3 : 1) : 1;
  }

  private buildMennekesImportPayload(
    cfg: Record<string, unknown> | null | undefined,
    destinationContext?: DestinationImportContext
  ): Record<string, unknown> | null {
    const body = this.optimizeConfig(cfg);
    if (!body) return null;

    if (destinationContext?.supportsSafetyOnRetries) {
      return body;
    }

    this.mennekesConditionalKeys.forEach(key => {
      if (!(key in body)) return;
      console.warn(
        `[import] Omitiendo ${key}: el cargador destino no soporta alimentación entre fases B1 ` +
        `(fases=${destinationContext?.numPhases ?? '?'}, firmware=${destinationContext?.firmwareVersion ?? '?'})`
      );
      delete body[key];
    });

    return Object.keys(body).length ? body : null;
  }

  /** Campos que envía la UI de RFID (rfid.component / grupos). */
  private buildRfidImportPayload(cfg: Record<string, unknown> | null | undefined): Record<string, unknown> | null {
    return this.optimizeConfig({
      rfid: cfg?.rfid,
      eocMode: cfg?.eocMode,
      enabled: cfg?.enabled,
    });
  }

  private extractImportElements(module: any): Array<{ name: string; type: string; cfg: Record<string, unknown> }> {
    if (!Array.isArray(module?.elements)) return [];

    return module.elements
      .map((el: any) => {
        const rawCfg = el?.data?.cfg ?? el?.cfg;
        const cfg = this.optimizeConfig(rawCfg);
        if (!cfg) return null;
        return { name: el.name, type: el.type, cfg };
      })
      .filter((el): el is { name: string; type: string; cfg: Record<string, unknown> } => !!el);
  }

  private buildSchedmanTasksPayload(cfg: Record<string, unknown> | null | undefined): { tasks: unknown[] } | null {
    if (!cfg?.tasks) return null;

    let tasks = cfg.tasks;
    if (typeof tasks === 'string') {
      try {
        tasks = JSON.parse(tasks);
      } catch {
        return null;
      }
    }

    if (!Array.isArray(tasks) || !tasks.length) return null;
    return { tasks };
  }

  private buildSchedmanImportRequests(module: any): Array<{
    module: string;
    body: { payload: { tasks: unknown[] }; elementName?: string };
  }> {
    const requests: Array<{
      module: string;
      body: { payload: { tasks: unknown[] }; elementName?: string };
    }> = [];

    const elementsWithTasks = (module.elements ?? [])
      .map((el: any) => ({ name: el.name, payload: this.buildSchedmanTasksPayload(el.cfg) }))
      .filter((el: any) => el.payload);

    if (elementsWithTasks.length) {
      elementsWithTasks.forEach((el: any) => {
        requests.push({
          module: el.name ? `schedman/${el.name}` : 'schedman',
          body: { payload: el.payload, elementName: el.name },
        });
      });
      return requests;
    }

    const modulePayload = this.buildSchedmanTasksPayload(module.cfg);
    if (modulePayload) {
      requests.push({
        module: 'schedman',
        body: { payload: modulePayload },
      });
    }

    return requests;
  }

  private buildOcppImportPayload(cfg: Record<string, unknown> | null | undefined): Record<string, unknown> | null {
    const rawUrl = String(cfg?.serverUrl ?? cfg?.url ?? '').trim();
    const serverUrl = rawUrl ? this.adaptOcppServerUrl(rawUrl) : undefined;

    return this.optimizeConfig({
      serverUrl,
      port: cfg?.port,
    });
  }

  /**
   * Adapta la URL OCPP al cargador destino si incluye el serial de origen
   * o si el perfil usa endpoint SERIAL con un identificador de cargador.
   */
  private adaptOcppServerUrl(serverUrl: string): string {
    if (!serverUrl) return serverUrl;

    if (this.serialOrgin && serverUrl.includes(this.serialOrgin)) {
      const adapted = serverUrl.split(this.serialOrgin).join(this.serial);
      console.log('[import] OCPP serverUrl: serial sustituido', { origen: serverUrl, destino: adapted });
      return adapted;
    }

    for (const profile of OCPP_TOP_PROFILES) {
      if (profile.endpoint.type !== 'SERIAL') continue;

      const matchesProfile = serverUrl.startsWith(profile.baseUrl)
        || (profile.endpoint.requiredPortInUrl && serverUrl.startsWith(`${profile.baseUrl}:${profile.port}`));
      if (!matchesProfile) continue;

      const lastSegment = this.getUrlLastPathSegment(serverUrl);
      if (this.looksLikeChargerSerial(lastSegment) && lastSegment.toUpperCase() !== this.serial.toUpperCase()) {
        const adapted = this.replaceUrlLastPathSegment(serverUrl, this.serial);
        console.log('[import] OCPP serverUrl: perfil SERIAL adaptado', {
          perfil: profile.id,
          origen: serverUrl,
          destino: adapted,
        });
        return adapted;
      }
      break;
    }

    return serverUrl;
  }

  private getUrlLastPathSegment(url: string): string {
    const withoutQuery = url.split('?')[0].split('#')[0];
    const segments = withoutQuery.split('/').filter(segment => segment.length > 0);
    const last = segments[segments.length - 1] ?? '';
    // Quitar credenciales embebidas en host si no hay path (ws://user@host)
    return last.includes('@') ? '' : last;
  }

  private replaceUrlLastPathSegment(url: string, newSegment: string): string {
    const match = url.match(/^([^?#]*)([?#].*)?$/);
    if (!match) return url;

    const pathPart = match[1];
    const suffix = match[2] ?? '';
    const lastSlash = pathPart.lastIndexOf('/');
    if (lastSlash === -1) return url;

    return `${pathPart.substring(0, lastSlash + 1)}${newSegment}${suffix}`;
  }

  private looksLikeChargerSerial(value: string): boolean {
    if (!value) return false;
    const upper = value.toUpperCase();
    if (this.serialOrgin && upper === this.serialOrgin.toUpperCase()) return true;
    return /^(EVVC|EVCC|ANC|XEO|CTM)[A-Z0-9]+$/i.test(upper);
  }

  private extractApiResponseMessage(data: any, isSuccess: boolean): string {
    if (!data || typeof data !== 'object') {
      return isSuccess ? 'Configuración aplicada correctamente.' : 'Error desconocido';
    }

    const message = typeof data.message === 'string' ? data.message.trim() : '';
    const code = data.code !== undefined && data.code !== null ? String(data.code) : '';

    if (message && code) return `${message} (código ${code})`;
    if (message) return message;
    if (code) return `Código de respuesta: ${code}`;

    return isSuccess ? 'Configuración aplicada correctamente.' : 'Error al aplicar la configuración.';
  }

  private buildImportSummary(): void {
    const successModules = this.importResults.filter(result => result.success).map(result => result.module);
    const failedModules = this.importResults.filter(result => !result.success).map(result => result.module);
    const retryHint = 'Te recomendamos volver a intentar grabar los módulos fallidos de forma individual desde sus ajustes.';

    if (!failedModules.length) {
      this.importSummaryType = 'success';
      this.importSummaryMessage = `Configuración aplicada correctamente en: ${successModules.join(', ')}.`;
      return;
    }

    if (!successModules.length) {
      this.importSummaryType = 'danger';
      this.importSummaryMessage = `No se pudo aplicar la configuración en: ${failedModules.join(', ')}. ${retryHint}`;
      return;
    }

    this.importSummaryType = 'warning';
    this.importSummaryMessage =
      `Aplicados con éxito: ${successModules.join(', ')}. ` +
      `Con error: ${failedModules.join(', ')}. ${retryHint}`;
  }

  close(){
    this.importErrorMessage = '';
    this.importSuccessMessage = '';
    this.importSummaryMessage = '';
    this.importResults = [];
    this.importedModules = [];
    this.selectedImportedModule = null;
    this.serialOrgin = '';
  }

}
